/*global jQuery crm:true*/

const crm = (function() {
    var tab = [];
    var loader = '<span class="updateLoaderIcon"></span>';
    var getActiveTab = function() {
        return $('#tabs-right .ui-tabs-active a');
    };

    return {
        ajaxRequestUri: $('#tabs-right .ui-tabs-active a').data('route'),
        change_asp: 0,
        isCurrentlyLoading: false,

        placeLoadIndicator: function(tab) {
            $(tab).prepend(loader);
        },

        removeLoadIndicator: function(tab) {
            $(tab).find('#loadIndicator').remove();
        },

        showTabOverlay: function() {
            $('#tab-overlay').height($('#tabs-right').innerHeight());
        },

        hideTabOverlay: function() {
            $('#tab-overlay').height(0);
        },

        serializeForm: function() {

            var selector = '#tabs-right .ui-tabs-active a',
                formName  = $(selector).attr('href'),
                activeForm = $(formName+'Form');

            return activeForm.serialize();
        },

        getPanel: function(id) {
            return $('#' + id + '.ui-tabs-panel');
        },

        /**
         * Gibt die finale, fuer den AJAX-Request erforderliche URL zurueck
         *
         * @param {String|Number} dataId
         * @returns {String}
         */
        getFinalRequestUri: function(dataId) {
            var route = crm.ajaxRequestUri;
            return (route + (isNaN(dataId) || dataId === 0 ? '' : dataId) +
                    window.location.search);
        },

        /**
         * Gibt die Content-ID des aktiven Tabs zurueck.
         *
         * @returns {String}
         */
        getActiveTabContentId: function() {
            return getActiveTab().attr('href').replace('#', '');
        }
    };
}());

window.crm = crm;

(function($) {
    'use strict';

    var init_tabs = (function() {

        var activeTab = null;
        var dataId = null;
        window.addEventListener('tab-change-element', function () {
            $('#saveBtn').show();
        });

        function showTabChangeConfirmationDialog(ui) {
            var showDialog = false;

            var formWidget = ui.oldPanel.find('form[widget="esearcher.form"]');
            if (formWidget.length != 0) {
                var dataSection = widget.getById(formWidget.attr('widgetid'));
                if (typeof dataSection != 'undefined' && dataSection.getStatus()) {
                    var tabClicked = ui.newTab.find('a');
                    var getText = $('#tab-overlay');
                    $('<div>').dialog({
                        title: getText.data('textDialogTitle'),
                        modal: true,
                        buttons: [{
                                text: getText.data('textDialogConfirm'),
                                position: '.modal-body',
                                click: function () {
                                    $('#saveBtn').click();
                                    $(this).dialog('destroy');
                                    $(document).bind('loadFinish.tabSaved', function () {
                                        dataSection.setStatus(false);
                                        tabClicked.click();
                                        $(document).unbind('loadFinish.tabSaved');
                                    });
                                }
                            },
                            {
                                text: getText.data('textDialogCancel'),
                                class: 'btn-negative',
                                position: '.modal-body',
                                click: function () {
                                    dataSection.setStatus(false);
                                    tabClicked.click();
                                    $(this).dialog('destroy');
                                }
                            }
                        ]
                    });
                    $('div.modal-dialog').addClass('modal-center-content');
                    showDialog = true;
                }
            }
            return showDialog;
        }

        /**
         * Erzeugt ein Objekt fuer Tab-Events.
         *
         * @param {String} tab Der Tab, fuer den das Event getriggert wird.
         * @param {Boolean} withPreventDefault Optionale Angabe (default false),
         *                                  ob eine preventDefault-Funktion
         *                                  integriert werden soll.
         * @returns {Object}
         */
        function makeEvent(tab, withPreventDefault) {
            var event = {
                tab: tab
            };

            if (withPreventDefault) {
                event._preventDefault = false;
                event.preventDefault = function () {
                    this._preventDefault = true;
                };
            }

            return event;
        }

        function loadContent(activeTab, panel, tabs) {
            crm.ajaxRequestUri = $(activeTab).find('a').data('route');

            if (activeTab) {

                var tabId = activeTab.find('a').attr('href').replace('#', '');
                $(panel).html('');

                crm.placeLoadIndicator(panel);

                var loader = new Esearcher.BlockLoader();

                loader.setAssetProcessing(true).mapBlocks({
                    'tabContent': $(panel),
                    'entityHeading': $('.entity-heading, title')
                }).setCallback(function(){
                    $('.ui-tabs-panel.activeTab').removeClass('activeTab');
                    $(panel).addClass('activeTab');
                    crm.removeLoadIndicator(panel);

                    var tabFinishEvent = makeEvent(tabId, false);
                    Esearcher.trigger('tabFinish', tabFinishEvent);
                    tabs.tabs('enable'); // Debouncing the tabs (the tabs can now being clicked again)
                    saveButton(dataId, panel);
                }).request(crm.getFinalRequestUri(dataId));

                $(document).trigger('tabFinalRoute', crm.getFinalRequestUri(dataId));
           }
        }

        /**
         * core function -> ready =)
         * if there is a pagination, it will be reloaded
         */
        function saveTab(values, dataId, panel) {
            var tabId = panel.attr('id');

            crm.showTabOverlay(); // Puts the red overlay over the form

            $(document).one('loadFinish', function() {
                $('.updateLoader').remove();
                var saveFinishEvent = makeEvent(tabId, false);
                Esearcher.trigger('saveFinish', saveFinishEvent);
            });

            var loader = new Esearcher.BlockLoader();

            loader.mapBlocks({
                'tabContent': panel,
                'entityHeading': $('.entity-heading, title'),
                'classifications': $('.tags'),
                'customHeading': $('.custom-heading')
            }).setCallback(function () {
                crm.hideTabOverlay();
            }).request(crm.getFinalRequestUri(dataId), values, 'POST');
        }

        function saveButton(dataId, panel) {
            $(document)
                    .off('click', '#saveBtn')
                    .on('click', '#saveBtn', function() {

                        // Triggers all save events. If preventDefault is set, we can interrupt the normal save routine (e.g. useful on tabs with multiple forms)
                        // For an example see ext/system/JobExport/scripts/save.js
                        var tabId = panel.attr('id');
                        var saveEvent = makeEvent(tabId, true);
                        Esearcher.trigger('save', saveEvent);
                        if (saveEvent._preventDefault) {
                            return;
                        }

                        // Updates the textarea values with the content of the CkEditor fields.
                        $('textarea.ckEditor').each(function(idx, el) {
                            el = $(el);
                            var id   = el.attr('id'),
                                data = CKEDITOR.instances[id].getData();
                            el.text(data);
                        });

                        var values = crm.serializeForm();
                        if (values == '') {
                            // we have no data to store!
                            return;
                        }
                        saveTab(values, dataId, panel);
                    });
        }

        function getTabId (tab) {
            return $(tab).find('a').attr('href')
                .replace('#', '');
        }

        return {
            load: function () {
                var tabs = $("#tabs-right");
                dataId = parseInt($('#dataId').val(), 10);

                tabs.tabs({
                    beforeActivate: function( event, ui ) { // Is triggered after a tab switch
                        if (showTabChangeConfirmationDialog(ui)) { // If the dialog is shown we have to interrupt the normal tab change logic
                            return false;
                        }
                        var newTabId = getTabId(ui.newTab);
                        var oldTabId = getTabId(ui.oldTab);
                        var tabEvent = makeEvent(newTabId, true);

                        // Triggers all tab events. If preventDefault is set, we can interrupt the normal tab change event.
                        Esearcher.trigger('tab', tabEvent);
                        if (tabEvent._preventDefault) {
                            return false;
                        }

                        $(document).trigger('tabChange', {
                            newTab: newTabId,
                            oldTab: oldTabId
                        });

                        tabs.tabs('disable'); // Debouncing the tabs
                        ui.oldPanel.html(''); // Remove the HTML from the old panel before we load the new content

                        if (typeof event.currentTarget !== 'undefined') {
                            location.hash = event.currentTarget.hash; // Writes the hash of the tab to the url
                        } else {
                            location.hash = '#' + newTabId;
                        }

                        loadContent(ui.newTab, ui.newPanel, tabs);
                    },
                    create: function( event, ui ) { // Is triggered if the tab is initial opened or opened in a new browser tab or the page is reloaded
                        tabs.tabs('disable');
                        loadContent(ui.tab, ui.panel, tabs);
                    }
                });
            }
        };
    }(jQuery));

    $(function() {
        init_tabs.load();
        $('.ui-tabs-anchor').keydown(function () {
            return false;
        });
    });

}(jQuery));
